import PropTypes from 'prop-types'
import React, { Suspense, lazy } from 'react'
import Base from './BaseContainer'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import Login from './LoginContainer'
import Header from './HeaderContainer'
import Crouton from './CroutonContainer'
import Loader from './LoaderContainer'
import Menu from './MenuContainer'
import Library from './LibraryContainer'
import Alert from '../components/AlertPopup/Alert'
import { fetchMediasActions, clearMediasActions } from '../services/ws/LibraryWS'
import { checkUserZoom } from '../ApplicationUtils'
import jQuery from 'jquery'
import AppEditorContent from '../components/AppsDashboard/AppEditorContent'
import Editor from '../components/App/Editor/Editor'
import { hasAuth, hasUserRight } from '../ContentUtils'

import styles from '../styles/styles.module.scss'
import Constants from '../services/constants/Constants'
import { Route, Switch, withRouter, matchPath } from 'react-router-dom'
import { fetchLocalesAction } from '../services/ws/LocaleWS'
import { fetchTypesAction } from '../services/ws/ContentWS'
import LoaderContainer from './LoaderContainer'
import { clearHttpStatus } from '../services/manager/HttpManager'
import { fetchAppsAction, clearAppsFromStoreAction, saveAppActions, fetchAllTeamsApps } from '../services/ws/AppWS'
import { fetchUsersAction } from '../services/ws/UserManagementWS'
import { fetchAccountAction } from '../services/ws/AuthWS'

const AppsDashboardContainer = lazy(() => import('./AppsDashboardContainer'))
const AppContainer = lazy(() => import('./AppContainer'))
const AccountContainer = lazy(() => import('./AccountContainer'))
const AdminContainer = lazy(() => import('./Admin/AdminContainer'))
const NoAccess = lazy(() => import('./NoAccess'))

let inactivityTimeout = null
let lastScrollTop = 0

class Root extends Base {
  constructor() {
    super()
    this._bind('_handleChangeView', '_handleScroll', '_handleScrollContent', '_handleOpenLibrary',
      '_handleCloseLibrary', '_handleLibChangePosition', '_handleWindowResize', '_handleTimeOut', 'closeZoomAlert',
      'handleEditApp',
      '_onUndoClick',
      '_onCloseClick',
      '_onChangeLang',
      '_onSaveClick',
      '_onChangeApp',
      '_onChangeFromOwner',
      '_validate',
      '_cleanErrors')
    this.state = {
      opened: window.innerWidth > 1024,
      fullHeader: true,
      libOpened: false,
      libFrom: 'left',
      libType: 'icons',
      libMediaTypes: ['IMAGE'],
      zoomAlert: false,
      previousPath: '',
      appEditorOpened: false,
      selectedMenuItem: 'dashboard',
      app: {},
      currentApp: {},
      hasNoAccessToApp: false,
    }
    this.isSearchingDeep = false
    this.hasFound = false
  }

  componentDidMount() {
    let path = matchPath(this.props.history.location.pathname, {
      path: '/application/:appId/:selectedMenuItem',
      exact: true,
      strict: false
    })
    if (path && path.params && path.params.selectedMenuItem) {
      this.setState({ selectedMenuItem: path.params.selectedMenuItem })
    }
    this.props.clearApps()
    this._resetAppRights()
    if (this.props.user.authtoken && !hasAuth(this.props.user, Constants.AuthConstants.PLAYER_ONLY)) {
      this.props.fetchApps(this.props.user.email)
      this.props.fetchTypes()
      this.props.fetchLocales()
      let hasCopyRight = hasAuth(this.props.user, Constants.AuthConstants.CREATE_COPY_APP)
      if (hasCopyRight) {
        this.props.fetchCopyUsers()
      }
      if (hasCopyRight || hasAuth(this.props.user, Constants.AuthConstants.CREATE_APP)) {
        this.props.fetchOwnerUsers()
      }
    }
    if (document.querySelector('#appComponent')) {
      document.querySelector('#appComponent').addEventListener('scroll', this._handleScroll)
    }

    this._handleTimeOut()
    // this.props.fetchTypes()
    // this.props.fetchLocales()
    window.addEventListener('click', this._handleTimeOut)
    window.addEventListener('dragenter', this._handleFileDragEnter)
    window.addEventListener('dragover', this._handleFileDragEnter)
    jQuery(window).on('dragleave', this._handleFileDragLeave)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location && nextProps.location.pathname) {
      if (nextProps.location.pathname !== this.state.previousPath) {
        this.setState({
          previousPath: nextProps.location.pathname,
          fullHeader: true,
        })
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ((!prevProps.user.authtoken && this.props.user.authtoken) || (prevProps.app.id && !this.props.app.id)) {
      window.location.reload();
    }
    // if (prevProps.app.id && this.props.app.id && prevProps.app.id !== this.props.app.id) {

    // }
    if (this.props.location && prevProps.location && this.props.location.pathname !== prevProps.location.pathname) {
      let path = matchPath(this.props.history.location.pathname, {
        path: '/application/:appId/:selectedMenuItem',
        exact: true,
        strict: false
      })
      if (path && path.params && path.params.selectedMenuItem) {
        this._handleCloseLibrary()
        this.setState({ selectedMenuItem: path.params.selectedMenuItem })
      }
    }
    if (!this.props.app.id && this.props.apps && this.props.user.authtoken) {
      let path = matchPath(this.props.history.location.pathname, {
        path: '/application/:appId/:selectedItem',
        exact: true,
        strict: false
      })
      let appId = path && path.params && parseInt(path.params.appId)
      if (appId) this._selectApp(appId)
    }
    this._onUpdate()
  }
  _selectApp = async (appId, allApps = this.props.apps, lookingDeep = false) => {
    let selectedApp
    allApps.forEach((app) => {
      if (app.id === appId) {
        selectedApp = app
        this.props.setApp(app)
        this._handleAppRights(app)
      } else if (app.children && app.children.length) {
        app.children.forEach((child) => {
          if (child.id === appId) {
            selectedApp = app
            this.props.setChildrenApp(child, app)
            this._handleAppRights(app)
          }
        })
      }
    })
    if (!selectedApp) {
      if (!lookingDeep && !this.isSearchingDeep) {
        this.isSearchingDeep = true
        let teams = [...this.props.user.teams, { owner: this.props.user.email }]
        let allApps = await fetchAllTeamsApps(teams)
        return this._selectApp(appId, allApps, true)
      } else if (lookingDeep) {
        this.props.history.push(`/noAccess/${appId}`)
      }
    }
  }
  componentWillUnmount() {
    if (document.querySelector('#appComponent')) {
      document.querySelector('#appComponent').removeEventListener('scroll', this._handleScroll)
    }
    window.removeEventListener('dragenter', this._handleFileDragEnter)
    window.removeEventListener('dragover', this._handleFileDragEnter)
    jQuery(window).off('dragleave', this._handleFileDragLeave)
  }
  _resetAppRights() {
    let user = this.props.user
    user.appRights = user.authorizations
    this.props.updateAccount(user)
  }
  _onUpdate() {
    if (!this.props.app.id && this.state.opened === false) this.setState({ opened: true })
    if (!this.props.app.id && this.state.libOpened === true) this.setState({ libOpened: false })
    if (document.querySelector('#appContent')) {
      document.querySelector('#appContent').addEventListener('scroll', this._handleScrollContent)
    }
  }
  _handleAppRights(app) {
    let that = this
    app.usersFO.forEach((appUser, index) => {
      if (that.props.user.email === appUser.userFO.email) {
        let user = that.props.user
        if (!appUser.isOwner) {
          user.appRights = appUser.profile.rights
        } else {
          user.appRights = user.authorizations
        }
        that.props.updateAccount(user)
      }
    })
  }
  _handleTimeOut() {
    if (inactivityTimeout) {
      clearTimeout(inactivityTimeout)
    }
    inactivityTimeout = setTimeout(() => {
      console.log('inactivity detected')
      if (this.refs.header && this.refs.header.getWrappedInstance()) {
        this.refs.header.getWrappedInstance()._handleHelp()
      }
    }, 1000 * 60 * 10)
  }

  _handleScroll(event) {
    let scrollTop = document.querySelector('#appComponent').scrollTop
    let slaakButton = document.querySelector('#slaask-button')
    if (slaakButton) {
      if (scrollTop > 75) {
        this.setState({ fullHeader: false })
        slaakButton.style.display = 'none'
      } else if (scrollTop < lastScrollTop) {
        this.setState({ fullHeader: true })
        slaakButton.style.display = 'block'
      }
    }
    lastScrollTop = scrollTop
  }

  _handleScrollContent(event) {
    if (document.querySelector('#appContent')) {
      let scrollTop = document.querySelector('#appContent').scrollTop
      let slaakButton = document.querySelector('#slaask-button')
      if (slaakButton) {
        if (scrollTop > 75) {
          this.setState({ fullHeader: false })
          slaakButton.style.display = 'none'
        } else if (scrollTop < lastScrollTop) {
          this.setState({ fullHeader: true })
          slaakButton.style.display = 'block'
        }
      }

      lastScrollTop = scrollTop
    } else {
      this.setState({ fullHeader: true })
    }
  }

  _handleChangeView() {
    this.setState({ opened: !this.state.opened })
  }

  _handleOpenLibrary(type, mediaTypes) {
    if (type !== 'icons') {
      if (type !== 'user' || !mediaTypes) {
        mediaTypes = ['IMAGE']
      }

      if (!this.state.libOpened === true) {
        this.props.clearMedias()
        // this.props.fetchMedias(this.props.app.id, mediaTypes)
      }

      this.setState({ libOpened: !this.state.libOpened, libType: 'user', libMediaTypes: mediaTypes })
    } else {
      this.setState({ libOpened: !this.state.libOpened, libType: 'icons' })
    }
    return !this.state.libOpened
  }

  _handleCloseLibrary() {
    this.setState({ libOpened: false })
  }

  _handleLibChangePosition(position) {
    this.setState({ libFrom: position })
  }

  _handleWindowResize() {
    if (window.innerWidth <= 1024) this.setState({ opened: false })
    else this.setState({ opened: true })
    if (!checkUserZoom()) {
      this.setState({
        zoomAlert: true,
      })
    }
  }

  closeZoomAlert() {
    this.setState({
      zoomAlert: false,
    })
  }

  _handleFileDragEnter(event) {
    let isFile = false
    let types = event.dataTransfer.types
    if (types[0] === 'application/x-moz-file' || // Firefox
      types[1] === 'Files' || // Firefox
      types[0] === 'Files' || // Chrome
      types[4] === 'Files' || // Safari
      types[types.length - 1] === 'com.apple.finder.node') { // Safari
      isFile = true
    }

    if (isFile) {
      let dropArea = document.querySelector('#uploaderFullsized')
      if (dropArea) {
        dropArea.style.display = 'block'
        document.querySelector('#LibraryHeader').classList.add('blur')
        document.querySelector('#ScrollLibrary').classList.add('blur')
      }
    }
  }

  _handleFileDragLeave(event) {
    if ((event.screenX === 0 && event.screenY === 0) || // Chrome
      (event.originalEvent.layerX === 0 && event.originalEvent.layerY === 0) || // Firefox
      (event.pageX === 0 || event.pageX === window.innerWidth || event.pageY === 0 || event.pageY === window.innerHeight)) { // Safari
      // stop your drag event here
      let dropArea = document.querySelector('#uploaderFullsized')
      if (dropArea) {
        dropArea.style.display = 'none'
        document.querySelector('#LibraryHeader').classList.remove('blur')
        document.querySelector('#ScrollLibrary').classList.remove('blur')
      }
    }
  }

  /* App editor */
  handleEditApp(app) {
    let newApp = JSON.parse(JSON.stringify(app))
    newApp.oldName = JSON.parse(JSON.stringify(app.name))
    let appName = ''
    app.locales.forEach((appLocale, index) => {
      if (appLocale.isDefault) {
        app.name.translations.forEach((translation, index) => {
          if (translation.locale.code === appLocale.locale.code) {
            appName = translation.translation
          }
        })
      }
    })
    newApp.name = appName
    this._validate(newApp)
    newApp.touched = { name: true, version: true, langs: true, stores: true, owner: true, copy: true }
    this.setState({ appEditorOpened: true, app: newApp, isEdit: true, currentApp: JSON.parse(JSON.stringify(newApp)) })
  }

  _onUndoClick() {
    this.setState({
      app: JSON.parse(JSON.stringify(this.state.currentApp)),
    })
  }

  _onCloseClick() {
    this.setState({ appEditorOpened: false, app: {} })
  }

  _onChangeLang() {

  }

  _onSaveClick() {
    let newApp = this._validate(this.state.app)
    if (!newApp.hasErrors) {
      let saveApp = JSON.parse(JSON.stringify(newApp))
      this._cleanErrors(saveApp)

      let email
      saveApp.usersFO.forEach((appUser, index) => {
        if (appUser.isOwner) {
          email = appUser.userFO.email
        }
      })

      this.props.copyUsers.forEach((user, index) => {
        if (user.email === email) {
          saveApp.usersFO[0].userFO.firstname = user.firstname
          saveApp.usersFO[0].userFO.lastname = user.lastname
          saveApp.usersFO[0].userFO.company = user.company
        }
      })

      let nameToSave = saveApp.name
      let defaultLocale
      saveApp.locales.forEach((appLocale, index) => {
        if (appLocale.isDefault) defaultLocale = appLocale.locale.code
      })
      if (saveApp.oldName && saveApp.oldName.translations) {
        saveApp.name = saveApp.oldName
        saveApp.oldName.translations.map((translation, index) => {
          if (translation.locale.code === defaultLocale) {
            saveApp.oldName.translations[index].translation = nameToSave
          }
          return null
        })
      } else {
        saveApp.name = { type: Constants.AppsConstants.CONTENTS.DEFAULT, translations: [] }
        saveApp.name.translations.push({ translation: nameToSave, locale: { code: defaultLocale } })
      }

      delete newApp.oldName
      delete saveApp.oldName

      this.props.updateApp(saveApp)
      this.setState({ app: {}, appEditorOpened: false })
    } else {
      newApp.touched = { name: true, version: true, langs: true, stores: true, owner: true, copy: true }
      this.setState({ app: newApp })
    }
  }

  _onChangeApp(app) {
    let newApp = this._validate(app)
    this.setState({ app: newApp })
  }

  _onChangeFromOwner(app) {
    this.props.fetchOwnerApps(app.fromOwner)
    this.setState({ app })
  }

  _validate(app) {
    app.errors = {}
    if (!app.name) {
      app.errors.name = I18n.t('Error.required')
    }
    if (!app.version) {
      app.errors.version = I18n.t('Error.required')
    }
    if (app.locales.length === 0) {
      app.errors.langs = I18n.t('Error.required')
    }
    if (!app.usersFO) {
      app.errors.owner = I18n.t('Error.required')
    } else {
      app.usersFO.forEach((appUser, index) => {
        if (appUser.isOwner && !appUser.userFO.email.trim()) {
          app.errors.owner = I18n.t('Error.required')
        }
      })
    }
    let oneStoreActive = false
    app.stores.forEach((store, index) => {
      if (store.active) {
        oneStoreActive = true
      }
    })
    if (!oneStoreActive) {
      app.errors.stores = I18n.t('Application.stores.error')
    }
    app.hasErrors = (Object.keys(app.errors).length !== 0)

    return app
  }

  _cleanErrors(app) {
    delete app.errors
    delete app.hasErrors
    delete app.touched
    delete app.fromApp
    delete app.copy
    delete app.fromOwner
  }

  render() {
    let appComponent
    let contentClassList = classNames(styles.content,
      this.state.appEditorOpened ? styles.blurred : null,
      this.state.opened ? null : styles.fullContent,
      this.props.app.id ? null : styles.fullWidth,
      this.props.location.pathname === '/account' ||
        this.props.location.pathname === '/account/myteam' ||
        this.props.location.pathname.indexOf('admin') > -1 ? styles.fullWidth : null,
      this.props.location.pathname.indexOf('admin') > -1 ? styles.adminContainer : null,
      this.state.fullHeader ? null : styles.fullHeight
    )

    if (this.props.user.authtoken) {
      const params = {
        handleLib: this._handleOpenLibrary,
        closeLib: this._handleCloseLibrary,
        handleLibChange: this._handleLibChangePosition,
      }
      let canCopy = hasAuth(this.props.user, Constants.AuthConstants.CREATE_COPY_APP)
      let isAdmin = hasAuth(this.props.user, Constants.AuthConstants.ADMIN)
      let canUseMapWize = hasUserRight(this.props.user, Constants.AppsConstants.USER_RIGHTS.CONFIG.DATA_MAPWIZE)

      appComponent = <div>
        <Header
          openedMenu={this.state.opened}
          fullHeader={this.state.fullHeader}
          refreshDisplayed={this.props.location.pathname.startsWith('/application')}
          teamDisplayed={this.props.location.pathname === '/'}
        />
        <Menu
          openedMenu={this.state.opened}
          fullHeader={this.state.fullHeader}
          onBurgerClick={this._handleChangeView}
          closeLib={this._handleCloseLibrary}
          onLibClick={this._handleOpenLibrary}
          handleEditApp={this.handleEditApp}
          appEditorOpened={this.state.appEditorOpened}
          selectedMenuItem={this.state.selectedMenuItem}
        />
        <div id='appComponent' className={contentClassList}>
          <Suspense fallback={<LoaderContainer force={true} />}>
            <Switch>
              <Route
                path={`/${Constants.RoutesConstants.account.account}`}
                render={() => <AccountContainer {...params} />}
              />
              <Route
                path={`/${Constants.RoutesConstants.admin.admin}`}
                render={() => <AdminContainer {...params} />}
              />
              <Route
                path={`/${Constants.RoutesConstants.app.dashboard}/${this.props.app.id}`}
                render={() => <AppContainer {...params} />}
              />
              <Route
                path={`/noAccess/:appId`}
                render={() => <NoAccess />}
                exact
              />
              <Route
                path={Constants.RoutesConstants.root}
                exact
                render={() => <AppsDashboardContainer {...params} />}
              />
            </Switch>
          </Suspense>

          {/* {childrenWithProps} */}
        </div>
        <Library
          isOpen={this.state.libOpened}
          closeLib={this._handleOpenLibrary}
          openFrom={this.state.libFrom}
          libType={this.state.libType}
          libMediaTypes={this.state.libMediaTypes}
          appEditorOpened={this.state.appEditorOpened}
        />
        <Editor
          className={styles.appEditor}
          currentLang={''}
          langs={[]}
          showEditor={this.state.appEditorOpened}
          content={{}}
          title={I18n.t('Application.list.updateApp')}
          bigEditor
          withFlex
          onCloseClick={this._onCloseClick}
          onChangeLang={this._onChangeLang}
          onSaveClick={this._onSaveClick}
          onUndoClick={this._onUndoClick}>
          <AppEditorContent
            tabIndex='-1'
            disabled={!this.state.appEditorOpened}
            app={this.state.app}
            canCopy={canCopy}
            isAdmin={isAdmin}
            canUseMapWize={canUseMapWize}
            userApps={this.props.userApps}
            currentUser={this.props.user}
            locales={this.props.locales}
            copyUsers={this.props.copyUsers}
            onChange={this._onChangeApp}
            onFromOwnerChange={this._onChangeFromOwner}
          />
        </Editor>
      </div>
    } else {
      appComponent = <Login />
    }

    return (
      <div className={styles.appGlobalContainer}>
        <Loader />
        {appComponent}
        <Crouton />
        <Alert
          opened={this.state.zoomAlert}
          messageTitle={'zoomTitle'}
          message={'zoomMessage'}
          confirmButtonTitle={''}
          cancelButtonTitle={'Ok'}
          confirmAction={null}
          cancelAction={this.closeZoomAlert}
        />
      </div>
    )
  }

}

Root.propTypes = {
  children: PropTypes.element,
  user: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  fetchMedias: PropTypes.func.isRequired,
  clearMedias: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
}

const mapStateToProps = ({ authWS: { user }, appWS: { app, apps, userApps, currentTeam, globalApp },
  userManagementWS: { copyUsers, ownerUsers },
  localeWS: { locales },
}) => ({
  user,
  globalApp,
  app,
  apps,
  userApps,
  currentTeam,
  copyUsers,
  ownerUsers,
  locales,
})

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  fetchMedias(appid, mediaTypes) {
    fetchMediasActions(dispatch, appid, null, null, mediaTypes).fetchMedias()
  },
  clearMedias() {
    clearMediasActions(dispatch).clearMediasFromStore()
  },
  updateApp(app) {
    saveAppActions(dispatch, app, null, null, null, true).updateApp()
  },
  fetchTypes() {
    fetchTypesAction(dispatch).fetchTypes()
  },
  fetchLocales() {
    fetchLocalesAction(dispatch).fetchLocales()
  },
  fetchApps(teamOwner) {
    fetchAppsAction(dispatch, null, null, null, teamOwner).fetchApps()
  },
  fetchOwnerApps(owner) {
    fetchAppsAction(dispatch, null, null, owner).fetchOwnerApps()
  },
  setApp(app) {
    fetchAppsAction(dispatch, app).setAppInStore()
  },
  setChildrenApp(app, apps) {
    fetchAppsAction(dispatch, app, apps).setChildAppInStore()
  },
  updateAccount(user) {
    fetchAccountAction(dispatch, user).setAccountInStore()
  },
  clearApps() {
    clearAppsFromStoreAction(dispatch).clearAppsFromStore()
  },
  clearUserApps() {
    clearAppsFromStoreAction(dispatch).clearUserAppsFromStore()
  },
  createApp(newApp, fromApp, userMail) {
    saveAppActions(dispatch, newApp, fromApp, null, userMail).createApp()
  },
  duplicateApp(dupApp) {
    saveAppActions(dispatch, dupApp).duplicateApp()
  },
  deleteApp(appId) {
    saveAppActions(dispatch, null, appId).deleteApp()
  },
  clearStatus() {
    clearHttpStatus(dispatch).clear()
  },
  fetchOwnerUsers() {
    fetchUsersAction(dispatch).GetOwnerUsers()
  },
  fetchCopyUsers() {
    fetchUsersAction(dispatch).GetCopyUsers()
  },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Root))
